import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import type { CreateSeasonPoolModel } from "~pages/SeasonPools/types/seasonPoolModel.ts";
import type { PoolResponse } from "~types/pool.ts";

export const useCreateSeasonPool = () => {
  const { sport, organizationId, seasonId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const notification = useNotification();

  return useMutation<PoolResponse, Error, CreateSeasonPoolModel>({
    mutationFn: async ({ poolCode, ...poolData }) =>
      await request<PoolResponse>(`${sport}/o/${organizationId}/seasons/${seasonId}/pools`, {
        method: "POST",
        body: {
          poolCode,
          ...poolData,
        },
      }),
    onSuccess: async () => {
      notification.success({
        message: formatMessage({ id: "pool.add.success" }),
        placement: "bottomRight",
      });

      await queryClient.invalidateQueries({ queryKey: ["seasonPools", sport, organizationId, seasonId] });
    },
  });
};
